import React from "react"
import {
  HStack,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Button,
  IconButton,
  Kbd,
  Text,
} from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import { useViewport, useZoom } from "../Editor"
import { TOOLBAR_CONFIG } from "./config"
import { useToolbarVariant } from "./EditorToolbar"

/** Zoom out, the zoom level with its menu, and zoom in; compact hides the − and + buttons. */
const ToolbarZoom = () => {
  const compact = useToolbarVariant() === "compact"
  const zoom = useZoom()
  const { min: minZoom, max: maxZoom } = useViewport((state) => state.zoomOptions)
  const onZoomIn = useViewport((state) => state.zoomIn)
  const onZoomOut = useViewport((state) => state.zoomOut)
  const onResetZoom = useViewport((state) => state.resetZoom)

  return (
    <HStack spacing={0} h="full">
      {!compact && (
      <IconButton
        aria-label="Zoom out"
        icon={<Icon icon="minus" size={3} />}
        onClick={onZoomOut}
        isDisabled={zoom <= minZoom}
        variant="ghost"
        rounded="none"
        h="full"
        color="gray.600"
        minW={0}
        px={2}
      />
      )}

      <Menu>
        <MenuButton
          as={Button}
          fontSize="sm"
          h="full"
          variant="ghost"
          rounded="none"
          px={
          compact
            ? TOOLBAR_CONFIG.zoom.buttonPaddingX.compact
            : TOOLBAR_CONFIG.zoom.buttonPaddingX.default
        }
        >
          <HStack
            spacing={
            compact
              ? TOOLBAR_CONFIG.zoom.iconTextSpacing.compact
              : TOOLBAR_CONFIG.zoom.iconTextSpacing.default
          }
            align="center"
          >
            <Text
              sx={{ fontVariantNumeric: "tabular-nums" }}
              fontSize={
              compact
                ? TOOLBAR_CONFIG.zoom.textSize.compact
                : TOOLBAR_CONFIG.zoom.textSize.default
            }
              width={
              compact
                ? TOOLBAR_CONFIG.zoom.textWidth.compact
                : TOOLBAR_CONFIG.zoom.textWidth.default
            }
            >
              {Math.round(zoom * 100)}%
            </Text>
            {compact && (
            <Icon icon="down-arrow" size={3} />
            )}
          </HStack>
        </MenuButton>
        <MenuList>
          <MenuItem
            onClick={onZoomIn}
            isDisabled={zoom >= maxZoom}
            justifyContent="space-between"
          >
            Zoom In
            <Kbd>⌘ =</Kbd>
          </MenuItem>
          <MenuItem
            onClick={onZoomOut}
            isDisabled={zoom <= minZoom}
            justifyContent="space-between"
          >
            Zoom Out
            <Kbd>⌘ -</Kbd>
          </MenuItem>
          <MenuDivider />
          <MenuItem onClick={onResetZoom} justifyContent="space-between">
            Reset Zoom
            <Kbd>⌘ 0</Kbd>
          </MenuItem>
        </MenuList>
      </Menu>

      {!compact && (
      <IconButton
        aria-label="Zoom in"
        icon={<Icon icon="plus" size={3} />}
        onClick={onZoomIn}
        isDisabled={zoom >= maxZoom}
        variant="ghost"
        rounded="none"
        h="full"
        minW={0}
        px={2}
        color="gray.600"
      />
      )}
    </HStack>
  )
}

export default ToolbarZoom
